<h2 style="font-weight: 300; margin-top: 0px; text-align: center">
  <strong><span style="color: #ffa626">BENVENUTO IN SKIMMING</span></strong>
</h2>
<div class="fusion-builder-row fusion-builder-row-inner fusion-row">
  <div class="
      fusion-layout-column
      fusion_builder_column
      fusion_builder_column_1_2
      fusion-builder-nested-column-1
      fusion-one-half
      fusion-column-first
      1_2
    " style="
      margin-top: 10px;
      margin-bottom: 10px;
      width: 50%;
      width: calc(50% - ((4%) * 0.5));
      margin-right: 4%;
    ">
    <div class="fusion-column-wrapper fusion-column-wrapper-1" style="
        background-color: #ffa626;
        padding: 30px 30px 30px 30px;
        background-position: left top;
        background-repeat: no-repeat;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
      " data-bg-url="">
      <div class="fusion-text">
        <p style="text-align: center"><strong>GARE CREATE DA TE</strong></p>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
      <div class="fusion-text">
        <p style="font-size: 60px; text-align: center">
          <strong>{{ profile.stats.myTenders.total }}</strong>
        </p>
        <h5 style="text-align: left">
          <span style="color: #666666">BOZZE: {{ profile.stats.myTenders.drafts }}</span><br />
          <span style="color: #666666">IN CORSO: {{ profile.stats.myTenders.ongoing }}</span><br />
          <span style="color: #666666">FASE DI SCONTO: {{ profile.stats.myTenders.discount }}</span><br />
          <span style="color: #666666">TRATTATIVA FINALE: {{ profile.stats.myTenders.deal }}</span>
        </h5>
      </div>
    </div>
  </div>
  <div class="
      fusion-layout-column
      fusion_builder_column
      fusion_builder_column_1_2
      fusion-builder-nested-column-2
      fusion-one-half
      fusion-column-last
      1_2
    " style="
      margin-top: 10px;
      margin-bottom: 10px;
      width: 50%;
      width: calc(50% - ((4%) * 0.5));
    ">
    <div class="fusion-column-wrapper fusion-column-wrapper-2" style="
        background-color: #666666;
        padding: 30px 30px 30px 30px;
        background-position: left top;
        background-repeat: no-repeat;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
      " data-bg-url="">
      <div class="fusion-text">
        <p style="text-align: center">
          <span style="color: #ffffff"><strong>GARE A CUI PARTECIPI</strong></span>
        </p>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
      <div class="fusion-text">
        <p style="font-size: 60px; text-align: center">
          <span style="color: #ffffff"><strong>{{
              profile.stats.partecipatedTenders.total
              }}</strong></span>
        </p>
        <h5 style="text-align: left">
          <span style="color: #ffffff">BOZZE: {{ profile.stats.partecipatedTenders.drafts }}</span><br />
          <span style="color: #ffffff">IN CORSO: {{ profile.stats.partecipatedTenders.ongoing }}</span><br />
          <span style="color: #ffffff">FASE DI SCONTO:
            {{ profile.stats.partecipatedTenders.discount }}</span><br />
          <span style="color: #ffffff">TRATTATIVA FINALE:
            {{ profile.stats.partecipatedTenders.deal }}</span>
        </h5>
      </div>
    </div>
  </div>
</div>
<div class="fusion-sep-clear"></div>
<div class="fusion-separator fusion-full-width-sep sep-none"
  style="margin-left: auto; margin-right: auto; margin-top: 10px"></div>
<div class="fusion-builder-row fusion-builder-row-inner fusion-row">
  <div class="
      fusion-layout-column
      fusion_builder_column
      fusion_builder_column_1_2
      fusion-builder-nested-column-3
      fusion-one-half
      fusion-column-first
      1_2
    " style="
      margin-top: 10px;
      margin-bottom: 10px;
      width: 50%;
      width: calc(50% - ((4%) * 0.5));
      margin-right: 4%;
    ">
    <div class="fusion-column-wrapper fusion-column-wrapper-3" style="
        background-color: #ffffff;
        padding: 30px 30px 30px 30px;
        background-position: left top;
        background-repeat: no-repeat;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
      " data-bg-url="">
      <div class="fusion-text">
        <p style="text-align: center">
          <strong>RESIDUO ABBONAMENTO <br />
            GARE</strong>
        </p>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
      <div class="fusion-text">
        <p style="text-align: center">
          <strong style="font-size: 60px">{{
            profile.prepaidCredits.remaining === null
            ? 0
            : profile.prepaidCredits.remaining
            }}</strong>&nbsp;<strong>Gare</strong>
        </p>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
      <div class="fusion-button-wrapper fusion-aligncenter">
        <style type="text/css">
          .fusion-button.button-1 {
            border-radius: 0px;
          }
        </style>
        <a (click)="buyPrepaidPacket()" class="
            fusion-button
            button-flat
            fusion-button-default-size
            button-default button-1
            fusion-button-default-span fusion-button-default-type
          " target="_self"><span class="fusion-button-text">ACQUISTA ABBONAMENTO GARE</span></a>
      </div>
    </div>
  </div>
  <div class="
      fusion-layout-column
      fusion_builder_column
      fusion_builder_column_1_2
      fusion-builder-nested-column-4
      fusion-one-half
      fusion-column-last
      1_2
    " style="
      margin-top: 10px;
      margin-bottom: 10px;
      width: 50%;
      width: calc(50% - ((4%) * 0.5));
    ">
    <div class="fusion-column-wrapper fusion-column-wrapper-4" style="
        background-color: #ffffff;
        padding: 30px 30px 30px 30px;
        background-position: left top;
        background-repeat: no-repeat;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
      " data-bg-url="">
      <div class="fusion-text">
        <p style="text-align: center">
          <strong>RESIDUO ABBONAMENTO PARTECIPAZIONI</strong>
        </p>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
      <div class="fusion-text">
        <p style="text-align: center">
          <strong style="font-size: 60px">{{
            profile.participationPrepaidCredits.remaining === null
            ? 0
            : profile.participationPrepaidCredits.remaining
            }}</strong>&nbsp;<strong>Partecipazioni</strong>
        </p>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
      <div class="fusion-button-wrapper fusion-aligncenter">
        <style type="text/css">
          .fusion-button.button-1 {
            border-radius: 0px;
          }
        </style>
        <a (click)="buyPrepaidParticipationPacket()" class="
            fusion-button
            button-flat
            fusion-button-default-size
            button-default button-1
            fusion-button-default-span fusion-button-default-type
          " target="_self"><span class="fusion-button-text">ACQUISTA ABBONAMENTO PARTECIPAZIONI</span></a>
      </div>
    </div>
  </div>
</div>

<div class="
    fusion-layout-column
    fusion_builder_column
    fusion_builder_column_1_2
    fusion-builder-nested-column-4
    fusion-one-half
    fusion-column-last
    1_2
  " style="
    margin-top: 10px;
    margin-bottom: 10px;
    width: 50%;
    width: calc(50% - ((4%) * 0.5));
  ">
  <div class="fusion-column-wrapper fusion-column-wrapper-4" style="
      background-color: #ffffff;
      padding: 30px 30px 30px 30px;
      background-position: left top;
      background-repeat: no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
    " data-bg-url="">
    <div class="fusion-text">
      <p style="text-align: center"><strong>SUPPORTO</strong></p>
    </div>
    <div class="fusion-sep-clear"></div>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 32px"></div>
    <div class="fusion-text">
      <p style="font-size: 15px; text-align: center">
        Hai bisogno di aiuto o hai una richiesta da sottoporci?
      </p>
    </div>
    <div class="fusion-sep-clear"></div>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 31px"></div>
    <div class="fusion-button-wrapper fusion-aligncenter">
      <style type="text/css">
        .fusion-button.button-3 {
          border-radius: 0px;
        }
      </style>
      <a href="/assistenza" class="
          fusion-button
          button-flat
          fusion-button-default-size
          button-default button-3
          fusion-button-default-span fusion-button-default-type
        " target="_blank"><span class="fusion-button-text">CONTATTACI</span></a>
    </div>
  </div>
</div>